<template>
    <svg viewBox="0 0 30.76 30.76">
        <circle cx="15.38" cy="15.38" r="10" :stroke="color" stroke-width="1" fill="none" />

        <circle cx="15.38" cy="15.38" r="7" :fill="color" />
    </svg>
</template>

<script>
export default {
    props: ['color']
}
</script>